import Cookies from 'js-cookie';
import { COUNTRY_LOCATIONS, OTHER_LOCATION, USA_COUNTRY } from './constants';

type Country = { currency: string; icon: string; code: string; locale: string; label?: string };

const DEFAULT_COUNTRY: Country = { currency: 'USD', icon: 'icoking-usd', code: 'US', locale: 'en-us' };
let localization = '';
let country = DEFAULT_COUNTRY;

export const COUNTRIES: Country[] = [
  {
    code: 'US',
    locale: '',
    icon: 'icoking-usd',
    currency: 'USD',
    label: 'United States',
  },
  {
    code: 'CA',
    locale: 'en-ca',
    icon: 'icoking-cad',
    currency: 'CAD',
    label: 'Canada',
  },
  {
    code: 'GB',
    locale: 'en-gb',
    icon: 'icoking-gbp',
    currency: 'GBP',
    label: 'United Kingdom',
  },
  {
    code: 'AU',
    locale: 'en-au',
    icon: 'icoking-aud',
    currency: 'AUD',
    label: 'Australia',
  },
];

export function setCurrentCountry(locale: string): Country {
  country = COUNTRIES.find(({ locale: cLocale }) => cLocale === locale) || DEFAULT_COUNTRY;
  return country;
}

export function getCountry(): Country {
  return country;
}

export function setLocalization(locale: string) {
  const { currency } = setCurrentCountry(locale);
  localizeLinks();
  // withCountry && Cookies.set('sel_country', code);
  Cookies.set('be_symbol', currency);
}

export function getLocale(): string {
  if (localization || typeof window === 'undefined') return localization;

  const locale = window.location.pathname.match(/en-(au|ca|gb)/);
  localization = locale ? locale[0] : DEFAULT_COUNTRY.locale;
  return localization;
}

export function getLocation(currentShowRoom: string, showrooms: any) {
  let store;

  if (country.code !== USA_COUNTRY) {
    store = COUNTRY_LOCATIONS[country.code] || OTHER_LOCATION;
    store['store_url'] = `/${country.locale}/stores/`;
  } else {
    store = showrooms[currentShowRoom.toLowerCase()] || OTHER_LOCATION;
    store['contact_url'] = '/contact/';
    store['store_url'] = '/stores/';
  }

  return store;
}

function localizeLinks() {
  if (!country.locale || country.locale === DEFAULT_COUNTRY.locale || typeof window === 'undefined') {
    return;
  }

  const domain = window.location.origin;

  const mapTags = () => {
    let hasATags = false;

    document.querySelectorAll('a').forEach(a => {
      if (a.href.startsWith(domain) && !a.href.startsWith(`${domain}/#`) && !a.href.match(/en-(ca|au|gb)\//)) {
        if (!a.classList.contains('change_currency')) {
          hasATags = true;
          const url = a.href.substring(domain.length);
          a.href = `${domain}/${country.locale}${url}`;
        }
      }
    });

    if (!hasATags) {
      clearInterval(intl);
    }
  };

  const intl = setInterval(mapTags, 100);
}
